module.exports = __webpack_public_path__ + "static/img/pingan_.991f2276.png";